/* eslint-disable no-unused-vars */
import BackgroundTimer from 'react-native-background-timer';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { isNative } from '@global/screens';
import { randomString } from '@global/helpers';
import { processUploadImageQueue } from '@global/tasks/upload-background';
import { processActivityTaskQueue } from '@global/tasks/activity-task';
// import {
//   openSqlite,
//   closeSqlite,
//   selectSqlite,
//   updateSqlite,
// } from '@/hooks/useSqlLite';
// import { uploadBackground } from '@global/helpers';

const backgroundStart = async () => {
  if (isNative) {
    // every 1 minutes
    const timer = 30000 * 1;
    BackgroundTimer.runBackgroundTimer(async () => {
      // const db = await openSqlite();
      // const sel = await selectSqlite('upload', db, { progress: 0 });
      // if (sel.length > 0) {
      //   const data = sel[0];
      //   await updateSqlite(
      //     'upload',
      //     db,
      //     { progress: 1 },
      //     { filename: data.filename },
      //   );
      //   uploadBackground(data.filename, JSON.parse(data.payload));
      // }
      const processed = await processActivityTaskQueue();
      if (processed) {
        await processUploadImageQueue();
      }
    }, timer);
  }
};

const backgroundStop = () => {
  if (isNative) {
    BackgroundTimer.stopBackgroundTimer();
  }
};

const storageName = {
  uploadImage: 'B2B-QUEUE-UPLOAD-BACKGROUND',
  activityTask: 'B2B-QUEUE-ACTIVITY-TASK',
  activityTaskDone: 'B2B-QUEUE-ACTIVITY-TASK-DONE',
};

const removeAllQueues = () => {
  Promise.all([
    AsyncStorage.removeItem(storageName.activityTask),
    AsyncStorage.removeItem(storageName.uploadImage),
  ]);
};

const pushToQueueImageUpload = async (payload) => {
  try {
    payload.uid = randomString(10);
    const oldProcess = await AsyncStorage.getItem(storageName.uploadImage);
    if (oldProcess) {
      const getProcess = JSON.parse(oldProcess);
      if (getProcess.findIndex((p) => p.uri == payload.image.uri) == -1) {
        getProcess.push(payload);
        await AsyncStorage.setItem(
          storageName.uploadImage,
          JSON.stringify(getProcess),
        );
      }
    } else {
      await AsyncStorage.setItem(
        storageName.uploadImage,
        JSON.stringify([payload]),
      );
    }
  } catch (error) {
    console.log('push-queue-error', error);
  }
};

let isQueueProcessing = false;

const pushToQueueActivityTask = async (payload) => {
  while (isQueueProcessing) {
    await new Promise((resolve) => setTimeout(resolve, 50));
  }

  isQueueProcessing = true;

  try {
    payload.uid = randomString(10);
    const oldProcess = await AsyncStorage.getItem(storageName.activityTask);
    const getProcess = oldProcess ? JSON.parse(oldProcess) : [];
    const isDuplicate = getProcess.some(
      (existing) => existing.activityId === payload.activityId,
    );

    if (isDuplicate) {
      getProcess.push(payload);
      await AsyncStorage.setItem(
        storageName.activityTask,
        JSON.stringify(getProcess),
      );
    } else {
      await AsyncStorage.setItem(
        storageName.activityTask,
        JSON.stringify([payload]),
      );
    }
  } catch (error) {
    console.log('push-queue-error', error);
  } finally {
    isQueueProcessing = false;
  }
};

// push to queue list
const pushToQueue = async (type, payload) => {
  if (type == 'upload-image-background') {
    await pushToQueueImageUpload(payload);
  } else if (type == 'submit-activity-task') {
    await pushToQueueActivityTask(payload);
  }
};

export {
  backgroundStart,
  backgroundStop,
  storageName,
  pushToQueue,
  removeAllQueues,
};
